<div class="container" id="translate-content">
    <main class="row eui-u-flex-justify-content-center">
        <article class="col-md-8">
            <button euiButton (click)="translate()">
                <eui-icon-svg icon="eui-language-selector" />
                {{ "actions.translate" | translate }}
            </button>
            <div class="eui-u-flex eui-u-flex-justify-content-center">
                <h1>Accessibility</h1>
            </div>
            <p>
                This statement applies to content published on the domain:
                <a href="https://webgate.ec.europa.eu/rasff-window/screen/search"
                    >‘https://webgate.ec.europa.eu/rasff-window/screen/search’
                </a>
                and was tested for version 3.10.0. It does not apply to other content or websites
                published on any of its subdomains. These websites and their content will have their
                own specific accessibility statement.
            </p>
            <p>
                This website is managed by DG SANTE. It is designed to be used by as many people as
                possible, including people with disabilities.
            </p>
            <p>You should be able to:</p>
            <ul class="eui-u-text-list">
                <li class="eui-u-text-list-item">[e.g. zoom up to 200% without problems]</li>
                <li class="eui-u-text-list-item">
                    navigate most of the website using just a keyboard.
                </li>
                <li class="eui-u-text-list-item">
                    navigate most of the website using a modern screen reader and speech recognition
                    software (on your computer or phone)]
                </li>
            </ul>
            <p>
                This website is designed to comply with the
                <a
                    href="https://www.etsi.org/deliver/etsi_en/301500_301599/301549/03.02.01_60/en_301549v030201p.pdf"
                    >technical standard for websites and mobile apps, EN 301 549, v.3.2.1</a
                >
                This closely follows level ‘AA’ of the
                <a href="https://www.w3.org/TR/WCAG21/"
                    >Web Content Accessibility Guidelines (WCAG) version 2.1</a
                >
            </p>
            <h2>Compliance status</h2>
            <p>
                This website is partially compliant with
                <a
                    href="https://www.etsi.org/deliver/etsi_en/301500_301599/301549/03.02.01_60/en_301549v030201p.pdf"
                    >technical standard EN 301 549 v.3.2.1</a
                >
                and the
                <a href="https://www.w3.org/TR/WCAG21/"
                    >Web Content Accessibility Guidelines (WCAG) 2.1 Level AA.</a
                >
                See
                <a routerLink="." fragment="non-accessible-content" href="#non-accessible-content"
                    >Non-accessible content</a
                >
                for more details.
            </p>
            <p>The website was last tested on 22-06-2026.</p>
            <h2>Preparation of this statement</h2>
            <p>This statement was reviewed on 22-06-2026.</p>
            <p>
                By our accessibility team. They did a self-assessment through manual and automated
                test. The automated tool used is Wave, and w3c validator
                (https://validator.w3.org/#!validate_by_input+with_options).
            </p>
            <h2>Feedback</h2>
            <p>
                We welcome your feedback on the accessibility of the ‘[RASFF Window]’ website.
                Please let us know if you encounter accessibility barriers:
            </p>
            <ul class="eui-u-text-list">
                <li class="eui-u-text-list-item">[Phone]: 0800 6 7 8 9 10 11</li>
                <li class="eui-u-text-list-item">
                    [Feedback form]:
                    <a href="https://european-union.europa.eu/contact-eu/write-us_en"
                        >Write to us</a
                    >
                </li>
            </ul>
            <p>
                <span class="eui-u-text-smaller"
                    >Commission européenne/Europese Commissie, 1049 Bruxelles/Brussel,
                    BELGIQUE/BELGIË - Tel. +32 22991111</span
                >
            </p>
            <p>
                We try to respond to feedback within 15 business days from the date of receipt of
                the enquiry by the responsible Commission department.
            </p>
            <h2>Compatibility with browsers and assistive technology</h2>
            <p>
                The ‘[RASFF Window]’ website is designed to be compatible with the following most
                used assistive technologies:
            </p>
            <p>
                The accessibility of the ‘[RASFF Window]’ website relies on the following
                technologies to work with the particular combination of web browser and any
                assistive technologies or plugins installed on your computer:
            </p>
            <ul class="eui-u-text-list">
                <li class="eui-u-text-list-item">
                    the latest version of Google Chrome and Edge browsers.
                </li>
                <li class="eui-u-text-list-item">
                    in combination with the latest versions of JAWS and NVDA.
                </li>
            </ul>
            <h2>Technical specifications</h2>
            <p>
                The accessibility of the ‘[RASFF Window]’ website relies on the following
                technologies to work with the particular combination of web browser and any
                assistive technologies or plugins installed on your computer:
            </p>
            <ul class="eui-u-text-list">
                <li class="eui-u-text-list-item">HTML</li>
                <li class="eui-u-text-list-item">WAI-ARIA</li>
                <li class="eui-u-text-list-item">CSS</li>
                <li class="eui-u-text-list-item">JavaScript</li>
            </ul>
            <h2 id="non-accessible-content">Non-accessible content</h2>
            <p>
                Despite our best efforts to ensure accessibility of the ‘[RASFF Window]’ website, we
                are aware of some limitations, which we are working to fix. Below is a description
                of known limitations and potential solutions. Please contact us if you encounter an
                issue not listed below.
            </p>
            <p>Known limitations for the ‘[RASFF Window]’ website:</p>

            <ol class="eui-u-text-list">
                <li class="eui-u-text-list-item">Some pages have poor colour contrast.</li>
                <li class="eui-u-text-list-item">
                    Many functionalities are not accessible using only a keyboard.
                </li>
                <li class="eui-u-text-list-item">
                    Some heading elements are not used consistently.
                </li>
                <li class="eui-u-text-list-item">
                    Some labels are not correctly connected with their corresponding form fields.
                </li>
                <li class="eui-u-text-list-item">
                    Some buttons and/or links don’t have readable text.
                </li>
            </ol>
        </article>
    </main>
</div>
